import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
// Nach den Grundfarben, damit das Thema der Firma sie überschreibt.
import '@tenant-theme';
import { App } from './App.tsx';
import { registerServiceWorker } from './lib/push.ts';

const root = document.getElementById('root');
if (!root) throw new Error('#root fehlt in index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
